import LocalizedStrings from "react-localization";
import en from "./locales/en";
import hi from "./locales/hi";

const localization = new LocalizedStrings({
  "en-US": en,
  hi,
});

export default localization;
